import React, { useRef } from 'react';
import { PageUI } from '@makemydeal/dr-activities-common';
import { TradeInRemovalConfirmationModal } from './TradeInRemovalConfirmationModal';

export const TradePageUI = (props) => {
    const pendingBackCallback = useRef<(() => void) | null>(null);

    const {
        shouldShowTradeInRemovalModal,
        shouldShowTradeInRemovalModalOnBack,
        showTradeInRemovalConfirmationModal,
        showTradeInRemovalModal,
        hideTradeInRemovalModal,
        removeTradeInAndNavigate,
        removeTradeInOnly,
        pendingNavigationRoute,
        footerProps,
        children,
        ...restProps
    } = props;

    const handleModalConfirm = () => {
        const backCb = pendingBackCallback.current;
        pendingBackCallback.current = null;
        if (backCb) {
            // Modal was triggered by back button — remove trade-in and execute the original back navigation
            removeTradeInOnly();
            backCb();
        } else {
            removeTradeInAndNavigate(pendingNavigationRoute);
        }
    };

    const buildFooterAriaLabels = () => {
        const backButtonText = footerProps.backButtonText || 'Back';
        const { skipButtonText } = footerProps;

        const backButtonAriaLabel =
            footerProps.backButtonAriaLabel ||
            (shouldShowTradeInRemovalModalOnBack
                ? `${backButtonText}, opens a dialog to confirm removing your trade-in`
                : footerProps.backButtonText
                    ? undefined
                    : 'Back to the previous Trade-In step');

        const skipButtonAriaLabel =
            footerProps.skipButtonAriaLabel ||
            (skipButtonText
                ? shouldShowTradeInRemovalModal
                    ? `${skipButtonText}, opens a dialog to confirm removing your trade-in`
                    : `${skipButtonText} and return to the start of Trade-In`
                : undefined);

        return { backButtonAriaLabel, skipButtonAriaLabel };
    };

    const interceptedFooterProps = footerProps
        ? {
            ...footerProps,
            ...buildFooterAriaLabels(),
            onBackButtonClick: footerProps.onBackButtonClick
                ? () => {
                    if (shouldShowTradeInRemovalModalOnBack) {
                        pendingBackCallback.current = footerProps.onBackButtonClick;
                        showTradeInRemovalModal();
                    } else {
                        footerProps.onBackButtonClick();
                    }
                }
                : undefined,
            onSkipButtonClick: footerProps.onSkipButtonClick
                ? () => {
                    if (shouldShowTradeInRemovalModal) {
                        showTradeInRemovalModal();
                    } else {
                        footerProps.onSkipButtonClick();
                    }
                }
                : undefined
        }
        : footerProps;

    return (
        <>
            <PageUI {...restProps} footerProps={interceptedFooterProps}>
                {children}
            </PageUI>
            <TradeInRemovalConfirmationModal
                show={!!showTradeInRemovalConfirmationModal}
                onCancel={hideTradeInRemovalModal}
                onConfirm={handleModalConfirm}
            />
        </>
    );
};
